<template>
  <b-modal 
    id="modal-delete-confirmation-batch" 
    centered 
    hide-footer
    title="Delete Batch"
    size="md"
    body-class="p-0">
    <div class="p-4">
      <!-- Question -->
      <p class="mb-4">Apakah Anda yakin ingin menghapus batch ini?</p>

      <!-- Course Title (optional) -->
      <!-- <div v-if="courseTitle" class="mb-3">
        <strong>{{ courseTitle }}</strong>
      </div> -->

      <!-- Warning Alert -->
      <div class="alert alert-danger d-flex align-items-center gap-3 mb-4" style="background-color: #fce4e4; border: 1px solid #f5c6cb; border-radius: 8px;">
        <i class="fe fe-alert-circle" style="font-size: 1.5rem; color: #e63757; margin-top: 2px;"></i>
        <p class="mb-0" style="color: #e63757; font-size: 0.95rem;">
          Pastikan tindakan ini tidak berdampak pada data lain!
        </p>
      </div>

      <!-- Divider -->
      <hr class="mb-4">

      <!-- Action Buttons -->
      <div class="d-flex justify-content-end gap-3">
        <button 
          class="btn px-4 py-2" 
          @click="cancelDelete"
          style="background-color: #fce4e4; color: #e63757; border: none; font-weight: 500; border-radius: 6px;">
          Cancel
        </button>
        <button 
          class="btn px-4 py-2" 
          @click="confirmDelete"
          style="background-color: #e63757; color: white; border: none; font-weight: 500; border-radius: 6px;">
          Delete
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ModalDeleteConfirmationBatch',
  props: {
    batchData: {
        type: Object,
        default: null,
    }
  },
  methods: {
    ...mapActions('courseCatalog', ['deleteTrainingEvent']),
    
    async confirmDelete() {
      if (!this.batchData?.id) {
        this.$swal('Error', 'Tidak ada pelatihan yang dipilih untuk dihapus', 'error');
        return;
      }

      try {
        // Call API delete
        await this.deleteTrainingEvent(this.batchData.id);
        
        // Close modal
        this.$bvModal.hide('modal-delete-confirmation-batch');
        
        // Show success message
        this.$swal('Terhapus', `Batch berhasil dihapus`, 'success');
        
        // Emit success event ke parent untuk refresh list
        this.$emit('deleted-success');
      } catch (error) {
        console.error('Error deleting course:', error);
        const errMessage = error.response?.data?.error || error.response?.data?.error || "Pelatihan belum berhasil dihapus";
        this.$swal('Error', errMessage, 'error');
      }
    },

    cancelDelete() {
      this.$bvModal.hide('modal-delete-confirmation-batch');
    }
  }
}
</script>

<style scoped>
.btn-close {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.btn-close:hover {
  opacity: 1;
}
</style>
